module.exports = __webpack_public_path__ + "static/img/icon-role.cb0f6b82.png";